import Vue from "vue"
import Axios from "axios"
import { Loading, Message } from 'element-ui';

// 設定ファイルの読み込み
const defaultSettings = require('@/settings.js')

// 予約在庫APIベースURL
const url = defaultSettings.hostName;

// ログインページのリダイレクトURL
const loginRedirectUrl = defaultSettings.loginRedirectUrl

// ベースURLに対する基本的な設定
const requestConfig = {
    baseURL: url,
    timeout: 30000,
    withCredentials: true
}
// サービス
const service = Axios.create(requestConfig)

// リクエストインターセプター
service.interceptors.request.use((config) => {
    // Loading.service();
    config.headers['Content-Type'] = 'application/json'
    return config
}, error => {
    return Promise.reject(error)
})

// レスポンスインターセプター
service.interceptors.response.use((response) => {
    // Loading.service().close();
    if (response.data && response.data.system_time) {
        window.sessionStorage.setItem('system_time', response.data.system_time)
    }
    return response.data
}, error => {
    const status = error?.request?.status;

    if (status === 401 || status === 403) {
        Message({
            message: 'ここから先へはログインが必要となります。<br>3秒後にログイン画面へリダイレクトします。',
            type: 'warning',
            dangerouslyUseHTMLString: true,
            duration: 3000
        });
        setTimeout(() => {
            window.location.href = loginRedirectUrl
        }, 3000);
    }

    Loading.service().close();
    return Promise.reject(error)
})


const request = {
    /**
	 * 
	 * formconfig:{}
	 * api_url:APIのURL
     * 
    */
    get(api_url,formconfig) {
        const header = {
            'Content-Type': 'application/json'
        };

        const config = {
            headers: Object.assign({}, header, formconfig),
            withCredentials: true
        };

        return Axios.get(
			url+api_url,
			config
		)
        .then(res => {
			return res
		})
    },
    /**
	 * 
	 * formdata: {}
	 * api_url: string
     * formconfig: {}
     * 
    */
    post(api_url,formdata,formconfig) {
        const header = {
            'Content-Type': 'application/json'
        };

        const config = {
            headers: Object.assign({}, header, formconfig),
            withCredentials: true
        };

        return Axios.post(
			url+api_url,
			formdata,
			config
		).then(res => {
			return res
		})
    }
};

export default request;
export {
    service
}